// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grpqQxQOQQIs50vdQTuL{margin-top:8px}", "",{"version":3,"sources":["webpack://./src/templates/projects/project-gallery.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".galleryContent {\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"galleryContent": "grpqQxQOQQIs50vdQTuL"
};
export default ___CSS_LOADER_EXPORT___;
